import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';
import { resendConfirmation } from 'store/slices/authSlice';

const COOLDOWN_SECONDS = 60;

interface Props {
  email: string;
}

/**
 * "Resend confirmation email" control with a client-side cooldown so users
 * can't spam-click. The backend also enforces a per-email cooldown, so this is
 * just UX — but it keeps the button honest and communicates the limit.
 */
const ResendConfirmation: React.FC<Props> = ({ email }) => {
  const dispatch = useAppDispatch();
  const [cooldown, setCooldown] = useState(0);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setInterval(() => setCooldown(c => Math.max(0, c - 1)), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  const handleClick = async () => {
    if (cooldown > 0 || !email) return;
    await dispatch(resendConfirmation({ email }));
    setSent(true);
    setCooldown(COOLDOWN_SECONDS);
  };

  if (cooldown > 0) {
    return (
      <span className="ecd-auth__hint" style={{ margin: 0 }}>
        {sent ? 'Confirmation sent — ' : ''}you can resend in {cooldown}s
      </span>
    );
  }

  return (
    <button type="button" className="ecd-auth__linkbtn" onClick={handleClick} disabled={!email}>
      Resend confirmation email
    </button>
  );
};

export default ResendConfirmation;
